<template>
  <v-card flat>
    <v-select
      :value="iid"
      :label="$t('message.idp_select.title')"
      class="mb-2"
      :items="data"
      item-text="label"
      item-value="value"
      :return-object="false"
      :disabled="data.length === 0"
      @input="$emit('update_iid', $event)"
    >
      <template v-slot:item="props">
        {{ props.item.label }}
      </template>
      <template v-slot:selection="props">
        <v-list-item class="pa-2 pl-0" style="min-height:auto">
          {{ props.item.label }}
        </v-list-item>
      </template>
    </v-select>
  </v-card>
</template>

<script>
import { http_error } from "../js/http_error";

export default {
  name: 'id_select',
  mixins: [http_error],
  props: {
    iid: String,
    path: String,
    auto_load: Boolean
  },
  data: function(){
    return {
      module_id: "7B",
      data: []
    }
  },
  mounted: function(){
    if(this.auto_load){
      this.get_idp_data();
    }
  },
  methods: {
    get_idp_data: function() {
      this.$http.get(this.$store.getters.api_endpoint + "/" + this.path)
        .then( response => {
          if(this.$store.getters.debug){
            console.log("response.data:" + JSON.stringify(response.data));
          }
          var data = [];
          for(var idp of response.data){
            data.push({
              "label": idp.name ? idp.name : idp.idp,
              "value": idp.iid
            });
          }
          this.data = data;
        })
        .catch( error => {
          if(this.http_error(error)){
            // 404だと何もしない
            if(error.response.status !== 404){
              this.$store.commit("setNotification", {
                type: "error",
                message: error.response.data
              });
            }
          }
        });
    }
  }
}
</script>
